export default __webpack_public_path__ + "static/media/partnerBanner.66e05f03.png";